import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const state = {
  orderFilterData: {
    orderStartTime: '',
    orderEndTime: '',
    outStoreIds: [],
    distributionMode: ''
  },
  callDriverInfo: {} // 呼叫骑手信息
}
const mutations = {
  [types.SET_ORDER_FILTER_DATA] (state, data) {
    state.orderFilterData.orderStartTime = data.orderStartTime
    state.orderFilterData.orderEndTime = data.orderEndTime
    state.orderFilterData.outStoreIds = data.outStoreIds.slice()
    state.orderFilterData.distributionMode = data.distributionMode
  },
  // 保存呼叫骑手信息
  [types.CALL_DRIVER_INFO] (state, data) {
    state.callDriverInfo = {
      ...data
    }
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
